
/**
 * @项目名称: work
 * @功能名称:
 * @文件名称: index
 * @Date: 2019/11/25
 * @Author: liux
 * @Copyright（C）2019 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */
import Report from './Report'
import baseReportPage from './baseReportPage'
import reportElement from './reportElement'

export default function (router, option) {
const report = new Report(option)

  baseReportPage(router,report)
  reportElement(report)
 return report
}
